import type { SvgIconProps } from '@mui/material/SvgIcon';

import { memo } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

import { BackgroundShape } from './background-shape';

// ----------------------------------------------------------------------

type SvgProps = SvgIconProps & { hideBackground?: boolean };

function PageNotFoundIllustration({ hideBackground, sx, ...other }: SvgProps) {
  return (
    <SvgIcon
      viewBox="0 0 480 360"
      xmlns="http://www.w3.org/2000/svg"
      sx={[
        (theme) => ({
          '--primary-light': theme.vars.palette.primary.light,
          '--primary-main': theme.vars.palette.primary.main,
          '--primary-dark': theme.vars.palette.primary.dark,
          '--primary-darker': theme.vars.palette.primary.darker,
          width: 320,
          maxWidth: 1,
          flexShrink: 0,
          height: 'auto',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {!hideBackground && <BackgroundShape />}

      <path
        fill="var(--primary-main)"
        d="M77 293c0-15.5 12.5-28 28-28h270c15.5 0 28 12.5 28 28s-12.5 28-28 28H105c-15.5 0-28-12.5-28-28z"
        opacity="0.08"
      />

      <path
        fill="#fff"
        d="M144 58h185c12.2 0 22 9.8 22 22v188c0 12.2-9.8 22-22 22H144c-12.2 0-22-9.8-22-22V80c0-12.2 9.8-22 22-22z"
      />
      <path
        fill="var(--primary-darker)"
        d="M144 58h185c12.2 0 22 9.8 22 22v188c0 12.2-9.8 22-22 22H144c-12.2 0-22-9.8-22-22V80c0-12.2 9.8-22 22-22zm0 18c-2.2 0-4 1.8-4 4v188c0 2.2 1.8 4 4 4h185c2.2 0 4-1.8 4-4V80c0-2.2-1.8-4-4-4H144z"
        opacity="0.18"
      />
      <path
        fill="url(#paint0_linear_1_119)"
        d="M171 108h88c5.5 0 10 4.5 10 10s-4.5 10-10 10h-88c-5.5 0-10-4.5-10-10s4.5-10 10-10zm0 42h130c5.5 0 10 4.5 10 10s-4.5 10-10 10H171c-5.5 0-10-4.5-10-10s4.5-10 10-10zm0 42h65c5.5 0 10 4.5 10 10s-4.5 10-10 10h-65c-5.5 0-10-4.5-10-10s4.5-10 10-10z"
      />
      <path
        fill="var(--primary-main)"
        d="M280 214h24v35h-24v-35zm-38-22h24v57h-24v-57zm76-50h24v107h-24V142z"
        opacity="0.9"
      />
      <path
        fill="#FFD666"
        d="M316 100c0-8.8 7.2-16 16-16h54c8.8 0 16 7.2 16 16v54c0 8.8-7.2 16-16 16h-54c-8.8 0-16-7.2-16-16v-54z"
      />
      <text
        x="359"
        y="130"
        fill="var(--primary-darker)"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        fontSize="42"
        fontWeight="800"
        textAnchor="middle"
      >
        404
      </text>
      <path
        fill="var(--primary-main)"
        d="M92 102c0-8.8 7.2-16 16-16h35v118h-35c-8.8 0-16-7.2-16-16v-86z"
        opacity="0.16"
      />
      <path
        fill="var(--primary-darker)"
        d="M102 120h30v10h-30v-10zm0 31h30v10h-30v-10zm0 31h30v10h-30v-10z"
        opacity="0.24"
      />

      <defs>
        <linearGradient
          id="paint0_linear_1_119"
          x1="78.3"
          x2="78.3"
          y1="187.77"
          y2="305.935"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--primary-light)" />
          <stop offset="1" stopColor="var(--primary-dark)" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
}

export default memo(PageNotFoundIllustration);
